import './latex-component';
import './latex-editor-menu';

import { BlockModel, defineBlockSchema } from '@blocksuite/store';
import { literal } from 'lit/static-html.js';

import { PiqueLatexBlockService } from './latex-service';

export type LatexProps = {
  latex: string;
};

export const PiqueLatexBlockSchema = defineBlockSchema({
  flavour: 'affine:embed-latex',
  props: (): LatexProps => ({
    latex: '',
  }),
  metadata: {
    version: 1,
    role: 'content',
  },
  toModel: () => new PiqueLatexBlockModel(),
});

export class PiqueLatexBlockModel extends BlockModel<LatexProps> {}

export const PiqueLatexBlockSpec = {
  schema: PiqueLatexBlockSchema,
  service: PiqueLatexBlockService,
  view: {
    component: literal`affine-latex`,
  },
};

declare global {
  namespace BlockSuite {
    interface BlockModels {
      'affine:embed-latex': PiqueLatexBlockModel;
    }
  }
}
